import type { StepExtended, StepState } from '@epilot/journey-logic-commons'
import type { JsonFormsReactProps } from '@jsonforms/react'
import { useMemo } from 'react'

import { protectAgainstRequiredNoUischema } from '../utils'

import StepContent from './StepContent'

export type StepComponentProps = {
  data: StepState
  onChange: JsonFormsReactProps['onChange']
  step: StepExtended
}

export const StepComponent = ({ data, onChange, step }: StepComponentProps) => {
  // clean up the step from any potential required blocks that are not in the uischema
  const requiredBlocks = step.schema?.required
  const uischema = step.uischema

  const cleanedRequired = useMemo(
    () => protectAgainstRequiredNoUischema(uischema, requiredBlocks),
    [uischema, requiredBlocks]
  )

  const schema = useMemo(() => {
    if (cleanedRequired.length !== requiredBlocks?.length) {
      return { ...step.schema, required: cleanedRequired }
    }

    return step.schema
  }, [cleanedRequired, requiredBlocks, step.schema])

  return (
    <StepContent
      data={data}
      onChange={onChange}
      schema={schema}
      step={step}
      uischema={uischema}
    />
  )
}

StepComponent.displayName = 'StepComponent'
